import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {Box, Container, FormControl, InputLabel, Paper, Select, Button, Chip, FormControlLabel, Switch} from "@mui/material";
import Api from "../../Services/Api";
import {DataGrid, GridFooter, GridFooterContainer, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import Title from "../Title";
import TextField from "@mui/material/TextField";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import Success from "../Snackbar/Success";
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material';

const DemandFeedsClosing = () => {


    const [demandFeedsClosing, setDemandFeedsClosing] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [pageSize, setPageSize] = React.useState(100);
    const [value, setValue] = React.useState(dayjs());
    const [editMessage, setEditMessage] = React.useState(null);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [bulkLoading, setBulkLoading] = React.useState(false);
    const [showOnlyUnconfirmed, setShowOnlyUnconfirmed] = React.useState(false);




    useEffect(() => {

        Api.demandClosing().then(r => {
            setDemandFeedsClosing(r)
            setLoading(false)
        })

    }, []);

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const columns = [
        {
            field: "id",
            headerName: "Id",
            type: 'number',
            editable: false,
            flex: 0.2,
            hide: true,
            minWidth: 50

        },
        {
            field: "month",
            headerName: "Month",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 100,
            valueGetter: (params) => {
                let date = new Date(params.row.month)
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                ];
                return monthNames[date.getMonth()] + " " + date.getFullYear()
            }


        },
        {
            field: "demand_user_name",
            headerName: "Demand",
            type: 'string',
            editable: false,
            flex: 0.3,
            minWidth: 150,
            valueGetter: (params) => params.row.demand_user?.name

        },
        {
            field: "supply_user_name",
            headerName: "Supply",
            type: 'string',
            editable: false,
            flex: 0.3,
            minWidth: 150,
            valueGetter: (params) => params.row.supply_user.name

        },
        {
            field: "needle",
            headerName: "Ext. Demand Id",
            type: 'string',
            editable: false,
            flex: 0.3,
            minWidth: 150,
            valueGetter: (params) => params.row.demand_feed?.needle

        },
        {
            field: "demand_feed_id",
            headerName: "D.Feed Id",
            type: 'number',
            editable: false,
            flex: 0.3,
            minWidth: 100,
            valueGetter: (params) => params.row.demand_feed?.id

        },
        {
            field: "supply_feed_id",
            headerName: "S. Feed Id",
            type: 'number',
            editable: false,
            flex: 0.3,
            minWidth: 100,
            valueGetter: (params) => params.row.supply_feed_id

        },
        {
            field: "total_revenue",
            headerName: "Total Revenue ($)",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 150,

        },
        {
            field: "billed_revenue",
            headerName: "Typ's Revenue ($)",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 150,
            valueGetter: (params) => params.row.platform_revenue

        },
        {
            field: "adjusted_revenue",
            headerName: "Adj. Revenue ($)",
            type: 'number',
            editable: true,
            flex: 0.2,
            minWidth: 150

        },
        {
            field: "note",
            headerName: "Notes",
            type: 'string',
            editable: true,
            flex: 0.4,
            minWidth: 50

        },
        {
            field: "confirmed",
            headerName: "Confirmed",
            type: 'boolean',
            editable: true,
            flex: 0.2,
            minWidth: 50

        },
    ]

    const onCellEditCommit = (params, event) => {
        Api.updateDemandClosing(params).then(r => setEditMessage(r))
    }

    const handleBulkConfirm = async (confirmed) => {
        if (selectedRows.length === 0) {
            setEditMessage({message: "Please select rows to update", success: false});
            return;
        }

        setBulkLoading(true);
        try {
            const response = await Api.bulkUpdateDemandClosing({
                ids: selectedRows,
                field: 'confirmed',
                value: confirmed
            });
            
            if (response.success) {
                setEditMessage(response);
                // Refresh the data to show updated confirmations
                const formattedDate = dayjs(value).format('YYYY-MM') + '-01';
                const refreshData = await Api.demandClosing({date: formattedDate});
                setDemandFeedsClosing(refreshData);
                setSelectedRows([]); // Clear selection after update
            }
        } catch (error) {
            setEditMessage({message: "Error updating records", success: false});
        } finally {
            setBulkLoading(false);
        }
    };

    const getSelectedRowsInfo = () => {
        const confirmedCount = demandFeedsClosing.filter(row => 
            selectedRows.includes(row.id) && row.confirmed
        ).length;
        const unconfirmedCount = selectedRows.length - confirmedCount;
        return { confirmedCount, unconfirmedCount };
    };

    const getFilteredData = () => {
        if (showOnlyUnconfirmed) {
            return demandFeedsClosing.filter(row => !row.confirmed);
        }
        return demandFeedsClosing;
    };




    return (

        <MainLayout>
            <Success successMessage={editMessage} setSuccessMessage={setEditMessage}>
                {editMessage?.message}
            </Success>

            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>
                    <Title>Closing</Title>
                    <Box sx={{mt:2}}>
                        <FormControl sx={{minWidth: 200}} size={"small"}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Year and Month"
                                    minDate={dayjs('2022-05-01')}
                                    maxDate={dayjs('2026-01-01')}
                                    value={value}
                                    size={"small"}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                        setLoading(true)
                                        console.log(newValue)

                                        // Format the date with day as 01 always
                                        const formattedDate = dayjs(newValue).format('YYYY-MM') + '-01';
                                        Api.demandClosing({date: formattedDate}).then(r => {
                                            setDemandFeedsClosing(r)
                                            setLoading(false)
                                        })
                                    }}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>


                        </FormControl>
                        
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={showOnlyUnconfirmed}
                                    onChange={(e) => setShowOnlyUnconfirmed(e.target.checked)}
                                    size="small"
                                />
                            }
                            label="Show only unconfirmed"
                            sx={{ ml: 3 }}
                        />
                    </Box>

                    {/* Bulk Actions Section */}
                    {selectedRows.length > 0 && (
                        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                                <Chip 
                                    label={`${selectedRows.length} selected`} 
                                    color="primary" 
                                    size="small" 
                                />
                                {(() => {
                                    const { confirmedCount, unconfirmedCount } = getSelectedRowsInfo();
                                    return (
                                        <>
                                            {confirmedCount > 0 && (
                                                <Chip 
                                                    label={`${confirmedCount} confirmed`} 
                                                    color="success" 
                                                    size="small" 
                                                />
                                            )}
                                            {unconfirmedCount > 0 && (
                                                <Chip 
                                                    label={`${unconfirmedCount} unconfirmed`} 
                                                    color="default" 
                                                    size="small" 
                                                />
                                            )}
                                        </>
                                    );
                                })()}
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    startIcon={<CheckIcon />}
                                    onClick={() => handleBulkConfirm(true)}
                                    disabled={bulkLoading}
                                >
                                    Confirm Selected
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    startIcon={<ClearIcon />}
                                    onClick={() => handleBulkConfirm(false)}
                                    disabled={bulkLoading}
                                >
                                    Unconfirm Selected
                                </Button>
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setSelectedRows([])}
                                    disabled={bulkLoading}
                                >
                                    Clear Selection
                                </Button>
                            </Box>
                        </Box>
                    )}

                    <DataGrid
                        rows={!loading ? getFilteredData() : []}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        processRowUpdate={(newRow, oldRow) => {

                            const [updatedField, newValue] = Object.entries(newRow).find(([key, value]) => oldRow[key] !== value) || [];
                            console.log("Field updated: ", updatedField);
                            console.log("New value: ", newValue);
                            Api.updateDemandClosing({id: newRow.id, field: updatedField, value: newValue}).then(r => {
                                setEditMessage(r)
                            })
                            return newRow


                        }}

                        checkboxSelection
                        rowSelectionModel={selectedRows}
                        onRowSelectionModelChange={(newSelection) => {
                            setSelectedRows(newSelection);
                        }}
                        disableRowSelectionOnClick
                        
                        autoHeight={true}
                        disableColumnSelector
                        sx={{
                            mt: 2,
                            mb: 2,
                        }}
                        density={"compact"}
                        slots={{
                            loadingOverlay: LoadingSkeleton,
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}
                        loading={loading}
                    />


                </Paper>
            </Container>
        </MainLayout>
)
}


export default DemandFeedsClosing